export const requireEmailVerification =
  (import.meta.env.VITE_REQUIRE_EMAIL_VERIFICATION ?? "true").toLowerCase() !==
  "false";
